import { useState, useRef, useEffect, useCallback } from "react";
// ** Reactstrap Imports
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import useAuth from '../../hooks/useAuth';

const AddTestimonial = () => {
  const { auth } = useAuth();

  // ** States
  let initialState = {
    testimonialTitle: "",
    testimonialDesc: "",
    authorName: ""
  };
  const [testimonialInfo, setTestimonialInfo] = useState(initialState);

  const fileInputRef = useRef();

  const [authorImg, setAuthorImg] = useState(null);
  const [mykey, setMyKey] = useState("");

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image");
      } else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const addImage = async (e) => {
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setAuthorImg(e.target.files[0]);
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    setTestimonialInfo((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const handleSaveClick = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("testimonialTitle", testimonialInfo.testimonialTitle);
    formData.append("testimonialDesc", testimonialInfo.testimonialDesc);
    formData.append("authorName", testimonialInfo.authorName);
    formData.append("authorImg", authorImg);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/testimonials/add-testimonial`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + auth.accessToken,
          },
        }
      );

      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setTestimonialInfo(initialState);
      setAuthorImg("");
      let st = Math.random();
      setMyKey(st);
      fileInputRef.current.value = "";
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  const handleReset = async (event) => {
    event.preventDefault();
    setTestimonialInfo(initialState);
    setAuthorImg(null);
    fileInputRef.current.value = "";
    let st = Math.random();
    setMyKey(st);
  };

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Add Testimonial</h5>
      </Row>
      <Row sm="12">
        <Card>
          <CardBody>
            <Col sm="12" className="mb-2">
              <Form>
                <div className="mb-1">
                  <Label className="form-label" for="title">
                    Testimonial Title <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="title"
                    type="text"
                    className="me-1"
                    name="testimonialTitle"
                    minLength={20}
                    maxLength={90}
                    required={true}
                    value={testimonialInfo.testimonialTitle}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="title">
                    Testimonial Description <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="testimonialDesc"
                    type="textarea"
                    className="me-1"
                    name="testimonialDesc"
                    minLength={60}
                    maxLength={520}
                    required={true}
                    value={testimonialInfo.testimonialDesc}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="title">
                    Author Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="authorName"
                    type="text"
                    className="me-1"
                    name="authorName"
                    required={true}
                    value={testimonialInfo.authorName}
                    onChange={handleChange}
                  />
                </div>

               
                <div className="mb-1">
                  <Label className="form-label" for="title">
                    Image <span className="text-danger">*(max size: 100KB, width: 400 x height 400)</span>
                  </Label>
                  <Input
                    id="authorImg"
                    type="file"
                    className="me-1"
                    name="authorImg"
                    accept="image/png, image/jpeg, image/jpg"
                    required={true}
                    key={mykey || ""}
                    ref={fileInputRef}
                    onChange={addImage}
                    />
                </div>
                {authorImg ? (
                  <div className="mb-3 mt-3">
                    <div>
                      <img
                        style={{ width: 180 }}
                        src={fileInputRef.current.value || ""}
                      />
                    </div>
                  </div>
                ) : null}

                <Row className="pt-2">
                  <Col>
                    <div className="mb-1">
                      <Button
                        block
                        color="success"
                        type="submit"
                        onClick={handleSaveClick}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-1">
                      <Button block color="warning" onClick={handleReset}>
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </CardBody>
        </Card>
      </Row>

      <Row sm="12" className="mt-4 text-center">
        <Link to={"/testimonials/view"} className="go_back">
          <BiLeftArrowAlt size={30} /> Go to Testimonial List
        </Link>
      </Row>
    </div>
  );
};

export default AddTestimonial;
